module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"lightpink","theme_color":"lightpink","display":"minimal-ui","icon":"src/images/icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"63137b2052f8c8f9cd385bc3d3ea1969"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
